<div class="correction-dialog">
  <header>
    <h2>Add Correction</h2>
    <div class="close" (click)="close()"></div>
  </header>

  <div *ngIf="loading" class="loading">Loading . . .</div>
  <div *ngIf="!loading && loadError" class="error">{{loadError}}</div>

  <ng-container *ngIf="!loading && !loadError && transaction && wording">

    <div class="subject">
      <span class="subject-name">{{wording.subject}}</span>
      <span class="subject-meta" *ngIf="wording.where"> &middot; {{wording.where}}</span>
      <span class="subject-meta"> &middot; {{transaction.time | rf:'dateTime'}}</span>
      <span class="subject-meta" *ngIf="wording.context"> &middot; {{wording.context}}</span>
    </div>

    <!-- Step 1: what happened -->
    <section *ngIf="!confirming">
      <div class="block">
        <label>The system says</label>
        <div class="statement">{{originalStatement()}}</div>

        <ng-container *ngIf="corrections.length">
          <div class="prior">
            <div class="prior-row" *ngFor="let p of priorStatements()">
              <span class="prior-text">Corrected to <b>{{p.text}}</b></span>
              <span class="meta">{{p.userName}} &middot; {{p.time | rf:'dateTime'}}</span>
            </div>
          </div>
          <div class="statement current">Now: {{currentStatement()}}</div>
        </ng-container>
      </div>

      <div class="block actually">
        <label>What really happened</label>
        <div class="answer">
          <select class="direction" [ngModel]="wording.directions.indexOf(direction)"
                  (ngModelChange)="selectDirection($event)">
            <option *ngFor="let d of wording.directions; let i = index" [ngValue]="i">{{d.label}}</option>
          </select>
          <span class="prefix" *ngIf="wording.prefix">{{wording.prefix}}</span>
          <input class="count" type="number" min="0" step="any" inputmode="decimal"
                 [ngModel]="countInput" (ngModelChange)="countChanged($event)"
                 (keydown)="countKeyDown($event)" (blur)="countBlur()" placeholder="0" />
          <span class="unit">{{unitLabel()}}{{wording.suffix}}</span>
        </div>

        <div class="flip" *ngIf="flipsDirection()">
          This changes the direction: it was recorded as <b>{{currentStatement()}}</b>,
          you are saying it was really <b>{{targetStatement()}}</b>.
        </div>

        <div class="effect" *ngIf="deltaRaw">
          <div class="effect-text">{{effect()}}</div>
          <div class="entry">Correction entry: {{entry()}}</div>
        </div>
        <div class="hint" *ngIf="deltaRaw === 0">That matches what the system already says &mdash; nothing to correct.</div>
      </div>

      <div class="note-row">
        <label>Note<span *ngIf="requireNote" class="required">*</span></label>
        <textarea [(ngModel)]="note" placeholder="Reason for this correction"></textarea>
      </div>

      <div class="buttons">
        <button class="button grey" (click)="close()">Cancel</button>
        <button class="button green" [disabled]="!canContinue()" (click)="continueToConfirm()">Continue</button>
      </div>
    </section>

    <!-- Step 2: confirmation -->
    <section *ngIf="confirming" class="confirm">
      <div class="confirm-title">Confirm Correction</div>
      <div class="change">
        <div class="change-row">
          <span class="change-label">From</span>
          <span class="change-value">{{currentStatement()}}</span>
        </div>
        <div class="change-row">
          <span class="change-label">To</span>
          <span class="change-value to">{{targetStatement()}}</span>
        </div>
      </div>
      <div class="effect">
        <div class="effect-text">{{effect()}}</div>
        <div class="entry">Correction entry: {{entry()}}</div>
      </div>
      <div class="note-block" *ngIf="note.trim()">
        <label>Note</label>
        <div class="note-value">{{note.trim()}}</div>
      </div>
      <div class="confirm-text">
        This adds a correction transaction immediately following the original. It cannot be edited &mdash;
        a further correction would be a new entry in the trail.
      </div>
      <div class="buttons">
        <button class="button grey" [disabled]="saving" (click)="back()">Back</button>
        <button class="button green" [disabled]="saving" (click)="submit()">{{saving ? 'Saving . . .' : 'Confirm Correction'}}</button>
      </div>
    </section>

    <div *ngIf="errorMessage" class="error">{{errorMessage}}</div>
  </ng-container>
</div>
